/* eslint-disable i18next/no-literal-string -- TanStack cache key segments */
export const IQ_DATA_SOURCE_QUERY_KEYS = {
  all: ['iq-data-sources'] as const,
  list: () => [...IQ_DATA_SOURCE_QUERY_KEYS.all, 'list'] as const,
} as const;
